import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2621e29e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-login c-secondary" }
const _hoisted_2 = { class: "types" }
const _hoisted_3 = { class: "input" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "input" }
const _hoisted_6 = {
  disabled: "",
  value: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "input" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "input" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "input getCode" }
const _hoisted_13 = {
  key: 0,
  class: "more"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "submit" }
const _hoisted_16 = { class: "input" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "input" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "submit" }

import userApi from '@/api/userApi';
import devices from '@/store/device';
import i18, { State as I18State } from '@/store/i18';
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore()
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)

const state = reactive({
    visible: false,
    type: 'qa',
    step: 0,
    token: '',
    account: '',
    qid: '',
    answer: '',

    email: '',
    smscode: '',
    cold: 0,

    password: '',
    again: '',
})
const qas = ref<Array<{ id: number, title: string }>>([])


onMounted(() => {
    loadQuestions()
})

async function loadQuestions() {
    qas.value = await userApi.getQas()
}

function isEmail(value: string) {
    return /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/.test(value)
}


function getSmsCode() {
    if (!state.email) {
        return devices.toast(store, lang.value.email_placeholder)
    }
    if (!isEmail(state.email)) {
        return devices.toast(store, lang.value.email_error)
    }
    if (state.cold > 0) {
        return
    }
    userApi.getEmailSms(state.email, 'forgot_email');
    state.cold = 60
    onTimer();
}

function onTimer() {
    state.cold--
    if (state.cold > 0) {
        setTimeout(onTimer, 1000);
    }
}

async function onNext() {
    if (state.type == 'qa') {
        if (!state.account) {
            return devices.toast(store, lang.value.account_placeholder)
        }
        if (!state.qid) {
            return devices.toast(store, lang.value.question_placeholder)
        }
        if (!state.answer) {
            return devices.toast(store, lang.value.answer_placeholder)
        }
        try {
            let { token } = await userApi.loginByQa(state.account, state.qid, state.answer)
            state.token = token
            state.step = 1
        } catch (e: any) {
            devices.toast(store, e.message)
        }
    } else {
        if (!state.email) {
            return devices.toast(store, lang.value.email_placeholder)
        }
        if (!isEmail(state.email)) {
            return devices.toast(store, lang.value.email_error)
        }
        if (!state.smscode) {
            return devices.toast(store, lang.value.smscode_placeholder)
        }
        try {
            let { token } = await userApi.loginByEmail(state.email, state.smscode)
            state.token = token
            state.step = 1
        } catch (e: any) {
            devices.toast(store, e.message)
        }
    }
}


async function onResetPassword() {
    if (!state.password) {
        return devices.toast(store, lang.value.password_placeholder)
    }
    if (!state.again) {
        return devices.toast(store, lang.value.again_placeholder)
    }
    if (state.password != state.again) {
        return devices.toast(store, lang.value.password_again_wrong)
    }
    try {
        await userApi.setPassword(state.token, state.password, state.password)
        devices.toast(store, lang.value.reset_success)
        onCancel()
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}


function onCancel() {
    emits('close')
}

function onTypeChange(value: string) {
    state.type = value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: onCancel
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(state).type == 'qa' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onTypeChange('qa')))
      }, _toDisplayString(_unref(lang).forget_qa), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(state).type == 'email' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onTypeChange('email')))
      }, _toDisplayString(_unref(lang).forget_email), 3)
    ]),
    (_unref(state).step == 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(state).type == 'qa')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).account) = $event)),
                    placeholder: _unref(lang).account_placeholder
                  }, null, 8, _hoisted_4), [
                    [_vModelText, _unref(state).account]
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).qid) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(lang).question_placeholder), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qas.value, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id
                      }, _toDisplayString(item.title), 9, _hoisted_7))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _unref(state).qid]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).answer) = $event)),
                    placeholder: _unref(lang).answer_placeholder
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _unref(state).answer]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(state).type == 'email')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).email) = $event)),
                    placeholder: _unref(lang).email_placeholder
                  }, null, 8, _hoisted_11), [
                    [_vModelText, _unref(state).email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_unref(state).cold > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(state).cold) + "S", 1))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "more link",
                        onClick: getSmsCode
                      }, _toDisplayString(_unref(lang).smscode_send), 1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).smscode) = $event)),
                    placeholder: _unref(lang).smscode_placeholder
                  }, null, 8, _hoisted_14), [
                    [_vModelText, _unref(state).smscode]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", { onClick: onNext }, _toDisplayString(_unref(lang).do_next), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(state).step == 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).password) = $event)),
              type: "password",
              placeholder: _unref(lang).password_placeholder
            }, null, 8, _hoisted_17), [
              [_vModelText, _unref(state).password]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).again) = $event)),
              type: "password",
              placeholder: _unref(lang).again_placeholder
            }, null, 8, _hoisted_19), [
              [_vModelText, _unref(state).again]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", { onClick: onResetPassword }, _toDisplayString(_unref(lang).do_reset_pwd), 1)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})